const rand = (a, b) => a + Math.random() * (b - a);
const approach = (cur, target, rate) => cur + (target - cur) * rate;

// Blink: quick close, short hold, slower open (ms).
function blinkAmount(t) {
  if (t < 0) return 0;
  if (t < 70) return (t / 70) ** 2;
  if (t < 100) return 1;
  if (t < 210) return 1 - ((t - 100) / 110) ** 0.8;
  return 0;
}

const GAZE_TARGETS = { thinking: [-0.7, -0.55], listening: [0, 0], speaking: [0, 0] };

// Turns session state + speech level into subtle, natural face motion. All amplitudes are deliberately small.
export class AvatarMotion {
  open = 0;
  gaze = [0, 0];
  gazeTarget = [0, 0];
  lean = 0;
  tilt = 0;
  blinkAt = performance.now() + rand(1200, 3000);
  blinkStart = -1;
  doubleBlink = false;
  nextSaccade = 0;

  frame(now, status, speech, reduced) {
    // Blinking — a little less often while listening, as people do when paying attention.
    if (this.blinkStart < 0 && now >= this.blinkAt) {
      this.blinkStart = now;
      this.doubleBlink = Math.random() < 0.12;
    }
    let blink = 0;
    if (this.blinkStart >= 0) {
      const t = now - this.blinkStart;
      blink = Math.max(blinkAmount(t), this.doubleBlink ? blinkAmount(t - 260) : 0);
      if (t > (this.doubleBlink ? 480 : 220)) {
        this.blinkStart = -1;
        this.blinkAt = now + (status === "listening" ? rand(3500, 7000) : rand(2600, 5600)) * (reduced ? 1.4 : 1);
      }
    }

    // Mouth follows the level of the audio that is actually playing; anything else closes it at once.
    const target = status === "speaking" ? Math.min(1, Math.max(0, (speech - 0.05) / 0.85)) ** 0.9 * (reduced ? 0.6 : 1) : 0;
    this.open = status === "speaking" ? approach(this.open, target, target > this.open ? 0.55 : 0.3) : 0;

    // Gaze: forward while listening or speaking, a soft glance away while thinking, small saccades when idle.
    if (!reduced && now >= this.nextSaccade) {
      const base = GAZE_TARGETS[status] || [0, 0];
      const spread = status === "idle" ? 0.55 : 0.18;
      this.gazeTarget = [base[0] + rand(-spread, spread), base[1] + rand(-spread, spread) * 0.6];
      this.nextSaccade = now + (status === "idle" ? rand(1400, 3800) : rand(900, 2200));
    }
    if (reduced) this.gazeTarget = [0, 0];
    this.gaze = [approach(this.gaze[0], this.gazeTarget[0], 0.18), approach(this.gaze[1], this.gazeTarget[1], 0.18)];

    // Head: breathing and slow sway; lean in while listening; tiny nods with speech.
    const s = now / 1000;
    this.lean = approach(this.lean, status === "listening" ? 1 : 0, 0.06);
    this.tilt = approach(this.tilt, status === "thinking" ? -1 : status === "listening" ? 0.6 : 0, 0.04);
    const motion = reduced ? 0 : 1;
    const breathe = Math.sin(s * 2 * Math.PI * 0.22);
    const tx = motion * (Math.sin(s * 0.43) * 1.2 + Math.sin(s * 0.17) * 0.8);
    const ty = motion * (breathe * 1.2 + this.open * 1.6 - this.lean * 3);
    const rot = motion * ((Math.sin(s * 0.31) * 0.35 + this.tilt * 0.6 + (this.open - 0.3) * 0.25 * (status === "speaking" ? 1 : 0)) * Math.PI / 180);
    const scale = 1 + motion * (breathe * 0.0035 + this.lean * 0.012);
    return { blink, open: this.open, gaze: this.gaze, head: [tx, ty, rot, scale] };
  }
}
